<template>
  <div class="grid grid-rows-[auto_1fr] overflow-hidden h-full bg-base-100">
    <ThreadsNav :show-back="true" :show-center="false" />
    <div class="pb-4 overflow-auto px-4">
      <!-- Use collapse for each item -->
      <div
        v-for="(item, index) in list"
        :key="item.title"
        class="collapse collapse-arrow bg-base-200 mb-2 rounded-box"
      >
        <!-- Collapse Title -->
        <input type="radio" name="mate-wish-accordion" :checked="index === 0" />
        <div class="collapse-title text-xl font-medium">
          {{ item.title }}
        </div>
        <!-- Collapse Content -->
        <div class="collapse-content flex flex-col gap-4">
          <!-- 祈愿主角 -->
          <div v-if="item.characterzz.length">
            <div class="text-sm font-semibold mb-2">参考图:</div>
            <!-- Use flex to display characters horizontally -->
            <div class="flex gap-2">
              <div
                v-for="c in item.characterzz"
                :key="c.mediaUrl"
                class="w-20 rounded-lg overflow-hidden"
              >
                <BaseImg :url="c.mediaUrl" ratio="3:4" fit="cover" />
              </div>
            </div>
          </div>

          <!-- 祈愿描述文字 -->
          <div>
            <div class="text-sm font-semibold mb-1">
              {{ $t(`mateWish.content`) }}:
            </div>
            <div class="text-sm opacity-80">
              <!-- Slightly dimmer text -->
              {{ item.content }}
            </div>
          </div>

          <!-- 祈愿图片 -->
          <div class="w-full rounded-lg overflow-hidden">
            <!-- Rounded corners -->
            <div class="text-sm font-semibold mb-1">
              {{ $t(`mateWish.return`) }}:
            </div>
            <img
              :src="item.imageMedia.url"
              class="w-full h-auto block"
              crossorigin="anonymous"
              @click="
                useGlobalModal().openMediaPreviewModal([item.imageMedia.url])
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";

const list = [
  {
    title: "样例1：纯文字",
    content:
      "六界交汇处虚空裂隙现上古秘宝传闻。各界为夺宝起纷争，魔界、仙界、神界等率先开战，妖界、人界、鬼界也卷入其中。混战致虚空裂隙崩塌，六界合力封印，秘宝消失，六界停战，休养生息。",
    characterzz: [],
    imageMedia: {
      url: `/img/mate-wish/demo1.png`,
    },
  },
  {
    title: "样例2：参考图配文",
    content:
      "幽灵船甲板在时脉风暴中倾斜，红发雷恩的火焰喷射器点燃了鱼鳞船长，粘稠的时脉原油从船舱裂缝喷涌，将水手们凝固成半透明雕塑。身后桅杆上挂着三百年前自己的航海日志，正被雨水冲刷出相同的绝望字句。",
    characterzz: [
      {
        name: "",
        mediaUrl: "/img/mate-wish/demo2-c.png",
      },
    ],
    imageMedia: {
      url: `/img/mate-wish/demo2.png`,
    },
  },
  {
    title: "样例3：多参考图配文",
    content: "拥抱一下",
    characterzz: [
      {
        name: "",
        mediaUrl: "/img/mate-wish/demo3-c1.png",
      },
      {
        name: "",
        mediaUrl: "/img/mate-wish/demo3-c2.png",
      },
    ],
    imageMedia: {
      url: `/img/mate-wish/demo3.png`,
    },
  },
  // {
  //   title: "样例4",
  //   content:
  //     "荆姬一直在研究魔法与大寒纪的联系，结交了一头体内有魔法能量的冰原狼，荆姬给它起名为睿疾。",
  //   characterzz: [
  //     {
  //       name: "",
  //       mediaUrl: "/img/mate-wish/demo4-c.png",
  //     },
  //   ],
  //   imageMedia: {
  //     url: `/img/mate-wish/demo4.png`,
  //   },
  // },
];
</script>
